const isSecureContext = typeof window !== 'undefined' && window.location.protocol === 'https:';

export const setCookie = (key: string, value: string, maxAgeSecs?: number): void => {
  if (typeof document === 'undefined') return;
  const secure = isSecureContext ? '; Secure' : '';
  const maxAge = maxAgeSecs != null ? `; Max-Age=${maxAgeSecs}` : '';
  document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; Path=/; SameSite=Strict${secure}${maxAge}`;
};

export const getCookie = (key: string): string | null => {
  if (typeof document === 'undefined') return null;
  const encoded = encodeURIComponent(key);
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    const eqIdx = trimmed.indexOf('=');
    if (eqIdx === -1) continue;
    const k = trimmed.slice(0, eqIdx);
    if (k === encoded) return decodeURIComponent(trimmed.slice(eqIdx + 1));
  }
  return null;
};

export const removeCookie = (key: string): void => {
  if (typeof document === 'undefined') return;
  const secure = isSecureContext ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(key)}=; Path=/; SameSite=Strict${secure}; Max-Age=0`;
};

export const clearCookiesByPredicate = (predicate: (key: string) => boolean): void => {
  if (typeof document === 'undefined') return;
  document.cookie.split(';').forEach((part) => {
    const k = decodeURIComponent(part.trim().split('=')[0]);
    if (predicate(k)) removeCookie(k);
  });
};
